import { DateTime } from 'luxon';

type DateInput =
  | {
      format: 'dd-MM-yyyy' | 'yyyy-MM-dd HH:mm:ss' | 'dd.MM.yyyy';
      dateString: string;
    }
  | Date;

export class DateVOv2 {
  private readonly date: DateTime;

  constructor(date?: DateInput) {
    if (!date) {
      this.date = DateTime.now().setZone('Europe/Kiev');
    } else if (date instanceof Date) {
      this.date = DateTime.fromJSDate(date).setZone('Europe/Kiev');
    } else {
      this.date = DateTime.fromFormat(date.dateString, date.format);
    }
  }

  getCurrentYear = () => {
    return this.date.year;
  };

  getCurrentMonth = () => {
    return this.date.month;
  };

  getLuxonKiev = () => {
    return this.date;
  };

  // Apr 14, 2025, 11:32 AM  or 18 квітня 2025 р. 10:16

  getDateString = (locale: string) => {
    if (locale === 'en') {
      return this.date.setLocale(locale).toLocaleString(DateTime.DATETIME_MED);
    }
    return this.date.setLocale(locale).toFormat("d MMMM yyyy 'р.' HH:mm");
  };
}
